module.exports = __webpack_public_path__ + "img/153.414327b7.png";